import React, { useState } from "react";
import { TimePicker } from "@material-ui/pickers";
import { useTranslation } from "@/langs/useTranslation";
import { TextField, Box, Button, FormHelperText } from "@material-ui/core";
import useStyles from "./reduceStyle";
import { IconTrash } from "@/components/Icon";

const ExecuteTime = ({ value, handleChange, readonly, errors }) => {
  const { t } = useTranslation();
  const [time1, setTime1] = useState("");
  const [time2, setTime2] = useState("");
  const classes = useStyles();

  const addTime = () => {
    if (!time1 || !time2) return;
    if (
      time1.hour() === undefined ||
      Number.isNaN(time1.hour()) ||
      time1.minute() === undefined ||
      Number.isNaN(time1.minute()) ||
      time2.hour() === undefined ||
      Number.isNaN(time2.hour()) ||
      time2.minute() === undefined ||
      Number.isNaN(time2.minute())
    )
      return;
    let beginTime, endTime;
    if (time1.hour() === time2.hour()) {
      if (time1.minute() < time2.minute()) {
        beginTime = time1;
        endTime = time2;
      } else {
        beginTime = time2;
        endTime = time1;
      }
    } else if (time1.hour() < time2.hour()) {
      beginTime = time1;
      endTime = time2;
    } else {
      beginTime = time2;
      endTime = time1;
    }
    handleChange({
      target: {
        name: "contentTemplateDetail.executeTimeRangeInfo",
        value: [
          ...value,
          {
            executeBeginTime: {
              hour: beginTime.hour(),
              minute: beginTime.minute()
            },
            executeEndTime: {
              hour: endTime.hour(),
              minute: endTime.minute()
            }
          }
        ]
      }
    });
    setTime1("")
    setTime2("")
  };

  const deleteTime = ind => {
    const newValue = [...value];
    newValue.splice(ind, 1);
    handleChange({
      target: {
        name: "contentTemplateDetail.executeTimeRangeInfo",
        value: newValue
      }
    });
  };

  return (
    <div>
      <Box display="flex" alignItems="center">
        <TimePicker
          ampm={false}
          disabled={readonly}
          value={time1}
          onChange={time => setTime1(time)}
          renderInput={props => <TextField {...props} />}
          maxTime={time2 ? time2 : undefined}
          key={time2 ? time2.toString() : "noMax"}
        />
        <span style={{ fontSize: 20, marginLeft: 16, marginRight: 16 }}>
          {" "}
          -{" "}
        </span>
        <TimePicker
          ampm={false}
          disabled={readonly}
          value={time2}
          onChange={time => setTime2(time)}
          renderInput={props => <TextField {...props} />}
          minTime={time1 ? time1 : undefined}
          key={time1 ? time1.toString() : "noMin"}
        />
        {!readonly && (
          <Button
            variant="contained"
            color="primary"
            onClick={addTime}
            style={{ marginLeft: 24 }}
          >
            {t({ defaultMessage: "新增时段" })}
          </Button>
        )}
      </Box>
      {value.length > 0 && (
        <div className={classes.timePaper}>
          {value.map((v, ind) => {
            return (
              <div className={classes.excuteTime} key={ind}>
                {ind + 1}.{" "}
                {`${String(v.executeBeginTime.hour).padStart(2, "0")}:${String(
                  v.executeBeginTime.minute
                ).padStart(2, "0")} - ${String(v.executeEndTime.hour).padStart(
                  2,
                  "0"
                )}:${String(v.executeEndTime.minute).padStart(2, "0")}`}
                {!readonly && (
                  <IconTrash
                    style={{ marginLeft: "auto", cursor: "pointer" }}
                    color="red"
                    onClick={() => deleteTime(ind)}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
      {!readonly && errors?.contentTemplateDetail?.executeTimeRangeInfo && (
        <FormHelperText error>
          {errors.contentTemplateDetail.executeTimeRangeInfo}
        </FormHelperText>
      )}
    </div>
  );
};

export default ExecuteTime;
